// product card subscription
setTimeout(function() {
  $(".rc_block__type__onetime").addClass("rc_block__type--active");
  $('body').on('click','.rc_label__autodeliver',function(){
  var atLeastOneIsChecked = $(this).find('input:checked').length > 0;
    if (atLeastOneIsChecked) {
      var finalprice = $(this).find('.rc_price.rc_price__autodeliver').text();
      $(this).closest('._product-inner').find('.specialsaleprice').text(finalprice);
    }
  });
  $('body').on('click','.rc_block__type__onetime .rc_label__onetime',function(){
      $(this).parent().addClass("rc_block__type--active");
      $(this).closest('.rc_container').find(".rc_block__type__autodeliver").removeClass("rc_block__type--active");
      $(this).closest('.rc_container').find("select[name='selling_plan']").prop('disabled', true);
    var onetimeprice = $(this).closest('._product-inner').find('.specialsaleprice').data('saleprice');
    $(this).closest('._product-inner').find('.specialsaleprice').text(onetimeprice);
  });
  setInterval(function(){
    $('._product-inner').each(function(){
        var finalprice = $(this).find('.rc_price.rc_price__autodeliver').text();
        $(this).find('.subscribe-onetimeprice').html(finalprice);
    });
  },500);
  $('body').on('click','.rc_block__type__autodeliver .rc_label__autodeliver',function(){
      $(this).parent().addClass("rc_block__type--active");
      $(this).closest('.rc_container').find(".rc_block__type__onetime").removeClass("rc_block__type--active");
      $(this).closest('.rc_container').find("select[name='selling_plan']").removeAttr('disabled');
      var onetimeprice = $(this).closest('._product-inner').find('.specialsaleprice').data('saleprice');
      $(this).closest('._product-inner').find('.specialsaleprice').text(onetimeprice);
    });
  $('.subscribe-btnbd').on('click', function(){
    $(this).toggleClass('active');
    $(".subscription-p-class").toggleClass('subscription-products');
    $('.onetimeprice-wrap').toggle();
    $('.subscribeprice-wrap').toggle();

    setInterval(function(){
      if($('.subscribe-btnbd').hasClass('active')){
        $(".rc_radio__autodeliver").trigger('click');
        $(".subscription-p-class").addClass('subscription-products');
        $('.onetimeprice-wrap').show();
        $('.subscribeprice-wrap').hide();
      } else {

        $(".subscription-p-class").removeClass('subscription-products');
        $('.onetimeprice-wrap').hide();
        $('.subscribeprice-wrap').show();
      }
    },500)

  if($('.subscribe-btnbd').hasClass('active')){
  } else {
  $(".rc_block__type__onetime:not(.rc_block__type--active) .rc_purchase_type_onetime").trigger('click');
  }

    });

});
  